<template>
  <v-container fluid class="pending pa-0 ma-0 white">
    <div
      class="pending__header d-flex align-center justify-space-between px-6 px-lg-12"
      :class="{ 'pending__header--desktop' : $vuetify.breakpoint.lg || $vuetify.breakpoint.xl }"
    >
      <logo width="95px" class="pending__logo" @click="$router.push('/')" />
      <div class="pending__menu">
        <v-avatar
          class="pending__avatar"
          size="32"
        >
          <span class="white--text font-weight-medium text-uppercase">{{ userInitials }}</span>
        </v-avatar>
        <user-menu />
      </div>
    </div>
    <div
      class="pending__content px-5 px-lg-0 mx-md-auto pt-4 pb-8 pb-lg-16"
      :class="{ 'pending__content--mobile' : $vuetify.breakpoint.xs || $vuetify.breakpoint.sm }"
    >
      <!-- HERE -->
      <div class="flex flex-column align-center text-center">
        <thanks-illustration
          class="mt-8 mt-lg-4 mb-9"
          :width="$vuetify.breakpoint.xs || $vuetify.breakpoint.sm || $vuetify.breakpoint.md ? '308px' : '490px'"
          :height="$vuetify.breakpoint.xs || $vuetify.breakpoint.sm || $vuetify.breakpoint.md ? '212px' : '338px'"
        />
        <h1 class="pending__title text-center mb-8 mb-lg-11">
          {{ $t('onboarding.pending-title', 'Thank you') }}
          <span class="blue--text">{{ user.attributes.firstname }}!</span>
        </h1>
        <p class="pending__subtitle text-center mb-16 mb-lg-9">
          {{ $t('onboarding.pending-content-1', 'We successfully received your application. We will review it carefully, and email you at') }}
          {{ userEmail }}
          {{ $t('onboarding.pending-content-2', 'within 48h maximum.') }}
        </p>
        <p class="pending__hint stepGrey--text text-center">
          {{ $t('onboarding.pending-hint-1', 'Any questions or issues with your application? Reach out to us via our') }}
          <help-center-link>
            <slot name="text">
              {{ $t(
                "common.help-center-widget",
                "Help Center widget"
              ) }}
            </slot>
          </help-center-link>
        </p>
      </div>
    </div>
  </v-container>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex';
  import userMixin from 'ocus-shared-resources/src/Mixins/user';
  import supportLink from '~/components/mixins/supportLink';
  import { APPLICATION_STEP } from '~/constants/applicationStep';
  import Logo from '~/assets/img/logo/logo.svg';
  import ThanksIllustration from '~/assets/img/onboarding/thanks.svg';
  import UserMenu from '~/components/onboarding/UserMenu.vue';
  import featureFlagsMixin from '~/components/mixins/featureFlags';
  import HelpCenterLink from '~/components/common/HelpCenterLink.vue';

  export default {
    components: {
      Logo,
      ThanksIllustration,
      UserMenu,
      HelpCenterLink,
    },

    mixins: [
      userMixin,
      supportLink,
      featureFlagsMixin,
    ],

    layout: 'ocus/onboarding',

    computed: {
      ...mapGetters({
        getApplicationStep: 'application/getApplicationStep',
      }),
      user() {
        return this.$auth?.user;
      },
      userInitials() {
        const initials = `${this.$auth?.user?.attributes?.firstname?.charAt(0)}${this.$auth?.user?.attributes?.lastname?.charAt(0)}`;
        return initials;
      },
      userEmail() {
        return this.$auth.user.attributes.email;
      },
    },

    async created() {
      /**
       * TODO: Refacto this part after acceptation of featIcAutoValidation
       */
      await this.fetchOperatorApplication({
        userId: this.user?.id,
        organizationId: this.user?.relationships?.organizations?.data[0]?.id,
        flag: this.featIcAutoValidation(),
      })
        .then(() => {
          if (this.getApplicationStep !== APPLICATION_STEP.WAITING_ACCEPTATION) this.$router.push('/');
        });
    },

    methods: {
      ...mapActions({
        fetchOperatorApplication: 'application/fetchOperatorApplication',
      }),
    },
  };
</script>

<style lang="scss" scoped>
.pending {
  min-height: 100vh;

  &__header {
    height: 50px;
    box-shadow: 0px 1px 1px 0px rgba(0, 0, 0, 0.1);

    &--desktop {
      height: 64px;
    }
  }

  &__logo {
    cursor: pointer;
  }

  &__avatar {
    background: linear-gradient(235.88deg, #789EFF 9.06%, #3462D6 100.59%)
  }

  &__content {
    max-width: 650px;
    width: 100%;

    &--mobile {
      max-width: 100%;

      .pending__title {
        font-size: 25px;
      }

      .pending__subtitle {
        font-size: 16px;
      }
    }
  }

  &__subtitle {
    font-size: 20px;
  }
}
</style>
